module.exports = __webpack_public_path__ + "static/img/lang.b74704ef.svg";